import { render } from "./EnableNotificationsPage.vue?vue&type=template&id=86839732&scoped=true"
import script from "./EnableNotificationsPage.vue?vue&type=script&lang=js"
export * from "./EnableNotificationsPage.vue?vue&type=script&lang=js"

import "./EnableNotificationsPage.vue?vue&type=style&index=0&id=86839732&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86839732"]])

export default __exports__